import { createReducer, on } from '@ngrx/store';
import { PdvActions } from '../actions';
import { EventModel } from 'src/app/models/event.model';
import { CompanyModel } from 'src/app/models/company.model';
import { PdvSettingsModel } from 'src/app/models/pdv-settings.model';

export interface PdvState {
  settings: PdvSettingsModel | null;
  company: CompanyModel | null;
  events: EventModel[];
  loading: boolean;
}

const initialState: PdvState = {
  settings: null,
  company: null,
  events: [],
  loading: false,
}

export const pdvReducers = createReducer(
  initialState,
  on(PdvActions.loadPdv, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(PdvActions.loadPdvSuccess, (state, { settings, company, events }) => {
    return {
      ...state,
      settings,
      company,
      events,
      loading: false,
    };
  }),
)
